import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyAYYWyvBMfnVKwmbElQspUIPcjf7ule0tk',
  authDomain: 'llab-firebase-worker.firebaseapp.com',
  databaseURL: 'https://llab-firebase-worker.firebaseio.com',
  projectId: 'llab-firebase-worker',
  storageBucket: 'llab-firebase-worker.appspot.com',
  messagingSenderId: '937187518260',
  appId: '937187518260'
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Realtime Database and get a reference to the service
const db = getDatabase(firebaseApp);

export { db };